<!-- Submitter strip. Right-side actions are content-projected — parents
     drop in <app-connection-template> for the standard Connect/Chat
     button set (matches V3 details page). -->
<div class="jc-v3-cps-rec-strip" *ngIf="name">
  <div class="jc-v3-cps-rec-av"
       [style.background]="(photoUrl && !imgFailed) ? 'transparent' : bg"
       [style.color]="fg" style="overflow:hidden;">
    <img *ngIf="photoUrl && !imgFailed" [src]="photoUrl" alt=""
         (error)="imgFailed = true"
         style="width:100%;height:100%;object-fit:cover;border-radius:50%;display:block;">
    <ng-container *ngIf="!photoUrl || imgFailed">{{ initials }}</ng-container>
  </div>
  <div class="jc-v3-cps-rec-info">
    <div class="jc-v3-cps-rec-line">
      <span class="jc-v3-cps-rec-prefix">{{ prefix }}</span>
      <strong class="jc-v3-cps-rec-name">{{ name }}</strong>
    </div>
    <div class="jc-v3-cps-rec-sub" *ngIf="role || organisation">
      <span *ngIf="role">{{ role }}</span>
      <span *ngIf="role && organisation" class="jc-v3-cps-rec-sep">·</span>
      <span *ngIf="organisation">{{ organisation }}</span>
    </div>
  </div>
  <div class="jc-v3-cps-rec-actions">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
